import { Component, OnInit } from '@angular/core';
import { AdminMenuService } from '../../../services/admin-menu.services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { moduloSeguridad } from '../../../diccionarios/seguridadModulo.js';
import { AdminMenu, ModeloAdminMenu, MantenerMenuGuardar } from '../../../models/adminMenu';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsAdminService } from '../../../utils/utilsAdmin.service';

@Component({
  selector: 'app-nivel1',
  templateUrl: './nivel1.component.html',
  styleUrls: ['./nivel1.component.css']
})
export class Nivel1Component implements OnInit {

  formulario: FormGroup;
  diccionarioModulo: any;

  rowData;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;

  modelo: ModeloAdminMenu;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private servicioWeb: AdminMenuService,
    private _utilsAdmin: UtilsAdminService,
    private servicioUtils: UtilsService
  ) { }

  ngOnInit() {

    this.diccionarioModulo = moduloSeguridad;
    const innclase = new AdminMenu();
    this.modelo = innclase.devolverModeloAdminMenu();

    this.getAllNivel1();
    this.componentGrid();

    this.formulario = this.fb.group({
      menuSuperior: ['', [Validators.required]],
      orden: ['', [Validators.required]]
    });

  }

  getAllNivel1() {
    this.servicioWeb.getAllNivel(1, 0).subscribe((resp: any[]) => {
      this.rowData = resp.sort((a, b) => a.orden - b.orden);
    }, (err) => {
      console.log(err);
    });
  }

  componentGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'NIVEL',
        field: this.modelo.nivelDescrip,
        sortable: true,
        resizable: true,
        filter: true
      },
      {
        headerName: 'DESCRIPCION',
        field: this.modelo.descripcion,
        sortable: true,
        resizable: true,
        filter: true,
        width: 350
      },
      {
        headerName: 'ORDEN',
        field: this.modelo.orden,
        sortable: true,
        resizable: true,
        filter: true,
        width: 150
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        // width: 150,
        cellRendererParams: {
          onClick: this.goNivel2.bind(this),
          label: this.diccionarioModulo.button.buttonsNombre.agregarN2,
          colorBoton: this.diccionarioModulo.button.buttonsCss.primary
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        // width: 150,
        cellRendererParams: {
          onClick: this.editarLinea.bind(this),
          label: this.diccionarioModulo.button.buttonsNombre.editar,
          colorBoton: this.diccionarioModulo.button.buttonsCss.success
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.eliminarLinea.bind(this),
          label: this.diccionarioModulo.button.buttonsNombre.eliminar,
          colorBoton: this.diccionarioModulo.button.buttonsCss.danger
        }
      }
    ];
    this.rowSelection = 'multiple';
  }//end componentGri()

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  NuevoMenuNivel1() {
    const descripcion = this.formulario.get('menuSuperior').value;
    const orden = this.formulario.get('orden').value;
    this.servicioUtils.confirmarSincronoPromesaNormal(
      {
        title: '¿Esta seguro que desea guardar un nuevo Menu Nivel 1 (' + descripcion + ')?',
        text: '',
        action: '',
        funcion: this.servicioWeb.devolverObservableOk(descripcion)
      }
    ).then((nuevaDescripcion: any) => {
      const llenarObjeto = new MantenerMenuGuardar(null, descripcion, orden);
      this.guardarMenuNivel1(llenarObjeto);
    }).catch((err) => {
      console.log(err);
    });
  }

  guardarMenuNivel1(innObjeto) {
    console.log(innObjeto);
    this.servicioWeb.guardarMenu(innObjeto).subscribe((resp) => {
      this.servicioUtils.mensajeOKVisto(`Se creo el registro correctamente.`, true, 3000);
      this.formulario.get('menuSuperior').reset();
      this.formulario.get('orden').reset();
      this.getAllNivel1();
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  }//

  editarLinea({ rowData }) {
    const data = { descripcion: rowData.descripcion, orden: rowData.orden };
    this._utilsAdmin.confirmarSincronoPromesaMenu(
      {
        title: '¿Está seguro que desea modificar el Menú (' + rowData.descripcion + ')?',
        action: '',
        funcion: this.servicioWeb.devolverObservableOk(data),
        data: data
      }
    ).then((obj: any) => {
      console.log(obj);
      const llenarObjeto = new MantenerMenuGuardar(rowData.id, obj.descripcion, obj.orden);
      this.actualizarMenuNivel1(llenarObjeto);
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizarMenuNivel1(innObjeto) {
    this.servicioWeb.actualizarMenu(innObjeto).subscribe((resp) => {
      this.getAllNivel1();
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  }//

  eliminarMenuNivel1(innId) {
    this.servicioWeb.eliminarId(innId).subscribe((resp) => {
      // this.getAllNivel1();
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  }//

  eliminarLinea({ rowData }) {
    this.servicioUtils.confirmarSincronoPromesaNormal(
      {
        title: '¿Esta seguro que desea Eliminar un nuevo Menu Nivel 1 (' + rowData.descripcion + ')?',
        text: '',
        action: '',
        funcion: this.servicioWeb.devolverObservableOk(rowData.descripcion)
      }
    ).then((nuevaDescripcion: any) => {
      this.eliminarMenuNivel1(rowData.id);
    }).catch((err) => {
      console.log(err);
    });
  }

  goNivel2({ rowData }) {
    localStorage.setItem('descripcionMenuSuperior', rowData.descripcion);
    localStorage.setItem('enviarMenuSuperior', rowData.id);
    this.router.navigate(['admin-seguridad/mantener-menu/2']);
  }

}//end class
